import { render, staticRenderFns } from "./SpecialSingleCategory.vue?vue&type=template&id=7c9c4012"
import script from "./SpecialSingleCategory.vue?vue&type=script&lang=js"
export * from "./SpecialSingleCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseProduct: require('/home/korzinka/www/front/components/base/Product.vue').default})
